module.exports = __webpack_public_path__ + "img/logo_aeat.8f50babe.png";